<wl-content-section [id]="id()" [theme]="theme()">
  <wl-steps
    [headingField]="headingField()!"
    [button]="button()!"
    [steps]="steps()!"
  />
</wl-content-section>
